import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";

const ROUTE_SEO = {
  "/testimonials": {
    title: "Client Testimonials",
    description:
      "See what clients say about NexTech PLM Solutions, Teamcenter implementation delivery, and engineering support.",
    keywords: "NexTech PLM testimonials, Teamcenter client reviews, PLM customer feedback Pune",
    path: "/testimonials",
  },
  "/feedback": {
    title: "Share Your Feedback",
    description:
      "Send your feedback to NexTech PLM Solutions about project delivery, support, and your overall experience.",
    keywords: "NexTech PLM feedback, PLM service feedback, Teamcenter support feedback",
    path: "/feedback",
  },
  "/blog": {
    title: "PLM and Teamcenter Blog",
    description:
      "Read NexTech PLM insights on Teamcenter administration, integrations, Active Workspace, audit logging, and PLM best practices.",
    keywords: "PLM blog, Teamcenter blog, PLM best practices, Teamcenter tips, Active Workspace articles",
    path: "/blog",
  },
  "/blog/audit-management": {
    title: "Audit Management in Teamcenter",
    description:
      "Learn how Teamcenter audit management tracks who changed product data, what changed, and when across your PLM environment.",
    keywords: "Teamcenter audit management, PLM audit tracking, product data audit, Teamcenter change history",
    path: "/blog/audit-management",
    type: "article",
  },
  "/blog/configure-store-and-forward": {
    title: "Configure Teamcenter Store and Forward for Remote Cache",
    description:
      "Step-by-step guide to Teamcenter store and forward setup for remote cache users, FMS configuration, and faster large-file transfers.",
    keywords: "Teamcenter store and forward, FMS remote cache, Teamcenter file transfer, store forward configuration",
    path: "/blog/Configure-Store-and-Forward",
    type: "article",
  },
  "/blog/logical-object-post": {
    title: "Logical Objects in Active Workspace",
    description:
      "See how logical objects simplify attribute synchronization between Teamcenter and Microsoft Office files in Active Workspace.",
    keywords: "Teamcenter logical objects, Active Workspace attributes, Office attribute sync, AW logical objects",
    path: "/blog/Logical-object-post",
    type: "article",
  },
  "/about/board-of-directors/sandip-dalvi": {
    title: "Sandip Dalvi",
    description:
      "Profile of Sandip Dalvi, Founder, Chairman and Managing Director at NexTech PLM Solutions, with deep Teamcenter and business leadership experience.",
    keywords: "Sandip Dalvi, NexTech PLM founder, PLM leadership Pune, Teamcenter expert",
    path: "/about/board-of-directors/sandip-dalvi",
  },
  "/about/board-of-directors/akshay-kothe": {
    title: "Akshay Kothe",
    description:
      "Profile of Akshay Kothe, Founder and PLM solution leader at NexTech PLM Solutions, specializing in Teamcenter deployment, migration, and integrations.",
    keywords: "Akshay Kothe, NexTech PLM co-founder, Teamcenter deployment expert, PLM migration specialist",
    path: "/about/board-of-directors/Akshay-Kothe",
  },
  "/about/board-of-directors/nicolas-marais": {
    title: "Nicolas Marais",
    description:
      "Profile of Nicolas Marais, Founder and business leader at NexTech PLM Solutions, with PLM, ALM, CAD, and software delivery expertise.",
    keywords: "Nicolas Marais, NexTech PLM founder, PLM ALM CAD expert, software delivery leader",
    path: "/about/board-of-directors/Nicolas-Marais",
  },
  "/teamcenter/mcad-integration/catia-integration": {
    title: "Teamcenter Integration for CATIA",
    description:
      "NexTech PLM Solutions delivers Teamcenter CATIA integration, title block synchronization, JT translation, migration, and performance tuning services.",
    keywords: "Teamcenter CATIA integration, CATIA PLM connector, CATIA data management, Teamcenter CATIA Pune",
    path: "/teamcenter/mcad-integration/catia-integration",
  },
  "/teamcenter/mcad-integration/pro-engineer-integration": {
    title: "Teamcenter Integration for Creo Pro/ENGINEER",
    description:
      "Get Teamcenter integration for Creo Pro/ENGINEER with attribute synchronization, seeded parts, JT translation, and migration support.",
    keywords: "Teamcenter Creo integration, Pro/ENGINEER PLM, Creo Teamcenter connector, Creo data management",
    path: "/teamcenter/mcad-integration/pro-engineer-integration",
  },
  "/teamcenter/mcad-integration/solidwork-integration": {
    title: "Teamcenter Integration for SolidWorks",
    description:
      "Implement Teamcenter SolidWorks integration with bidirectional attribute mapping, seeded parts, JT translation, and controlled CAD data workflows.",
    keywords: "Teamcenter SolidWorks integration, SolidWorks PLM, SolidWorks data management, Teamcenter SolidWorks connector",
    path: "/teamcenter/mcad-integration/solidwork-integration",
  },
  "/teamcenter/mcad-integration/nx-integration": {
    title: "Teamcenter Integration for NX",
    description:
      "NexTech PLM Solutions provides Teamcenter NX integration, title block synchronization, complex attribute mapping, and legacy data migration services.",
    keywords: "Teamcenter NX integration, NX PLM connector, Siemens NX data management, NX Teamcenter Pune",
    path: "/teamcenter/mcad-integration/nx-integration",
  },
  "/teamcenter/mcad-integration/autocad-integration": {
    title: "Teamcenter Integration for AutoCAD",
    description:
      "Connect AutoCAD with Teamcenter for managed CAD data, title block synchronization, process consistency, and faster engineering collaboration.",
    keywords: "Teamcenter AutoCAD integration, AutoCAD PLM, AutoCAD data management, Teamcenter AutoCAD connector",
    path: "/teamcenter/mcad-integration/autocad-integration",
  },
  "/teamcenter-solidedge-integration": {
    title: "Teamcenter Integration for Solid Edge",
    description:
      "Teamcenter Solid Edge integration services for synchronized CAD data, attribute mapping, seeded parts, and JT translation.",
    keywords: "Teamcenter Solid Edge integration, Solid Edge PLM, Solid Edge data management, Teamcenter Solid Edge connector",
    path: "/teamcenter-solidedge-integration",
  },
};

const normalizePathname = (pathname = "/") => {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "").toLowerCase();
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  const seo = ROUTE_SEO[normalizePathname(pathname)];

  if (!seo) {
    return null;
  }

  return <Seo {...seo} />;
};

export default RouteSeo;